// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ApiResponse } from 'services/_api';
import { Types, ConsultarCpfCinResponsavel } from './types';

export function consultarCpfCinResponsavelRequest(
	token: string,
	data: string,
	instanceRequest?: string,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CPF_CIN_RESPONSAVEL_REQUEST,
		token,
		payload: data,
		instanceRequest,
	};
}
export function consultarCpfCinResponsavelSuccess(
	payload: ConsultarCpfCinResponsavel,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CPF_CIN_RESPONSAVEL_SUCCESS,
		payload,
	};
}
export function consultarCpfCinResponsavelFailure(
	payload: ApiResponse,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CPF_CIN_RESPONSAVEL_FAILURE,
		payload,
	};
}
export function consultarCpfCinResponsavelClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CPF_CIN_RESPONSAVEL_CLEAR,
		payload: null,
	};
}
